export default "__VITE_ASSET__UfLjeRst__"